import React from "react";
import "./Dashboard.css";
import {Container, Row} from "react-bootstrap";
import LiveChat from 'react-livechat';
import {mygaSession} from "../../scripts/myga-session";
import AppPageHeader from "../Application/AppPageHeader/AppPageHeader";
import {NassauLog} from "../../scripts/myga-utils";

class MMRateList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {rates: [], effectiveDate: ''};
  }

  componentDidMount() {
    NassauLog(mygaSession.getBankRates());
    let rates = mygaSession.getBankRates();
    let effectiveDate = rates.effectiveDate;
    rates.moneyMarketRates = rates.moneyMarketRates.map(item => {
      item.rate = parseFloat(item.rate).toFixed(2) + '%';
      return {
        ...item,
        effectiveDate
      }
    });
    this.setState({rates: rates.moneyMarketRates});
  };

  headerStyles = {
    fontSize: '.7em',
    backgroundColor: 'var(--HeaderBackgroundYellow)'
  };

  rightStyles = {
    textAlign: 'right'
  };

  renderRow = data => {
    return (
      <Row style={{marginBottom: '1em'}}>
        <Container className={'p-0'}>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div className={'col-6'}>{data.institution}</div>
            <div className={'col-6'} style={{fontSize: '.8em', ...this.rightStyles}}>{data.account}</div>
          </div>

          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div className={'col-7'} style={{fontSize: '.8em'}}>Minimum Deposit ${data.minimum}</div>
            <div className={'col-5'} style={this.rightStyles}>{data.rate}</div>
          </div>
        </Container>
      </Row>

    )
  };

  title = 'Money Market Rates';
  render() {

    return (


      <Container className="page-area noselect">
        <div className={'page-content-area'}>
        <AppPageHeader fullPage headerLabel={this.title} updatePage={this.props.updatePage}/>
        <Container className={'p-0'} style={{overflowY: 'auto'}}>
          <div style={{paddingTop: '1em'}}/>
          {this.state.rates.map(item => (this.renderRow(item)))}
          <div style={{marginBottom: '2em'}}/>
        </Container>
          </div>
        <LiveChat license={11222357} group={2}/>
      </Container>


    );

  }
}

export default MMRateList;